import { useTranslation } from 'react-i18next';
import QRCODE from '../../assets/images/qrcode.png';
import { Icon } from '../header/draft/Icon';
import { GlassSurface } from '../profile/GlassSurface';
import './open-app-qr.css';

type OpenAppQrPanelProps = {
  onClose: () => void;
  variant?: 'modal' | 'sidebar';
  /** 모달에서만 하단 확인 버튼 */
  showConfirmButton?: boolean;
};

export function OpenAppQrPanel({
  onClose,
  variant = 'modal',
  showConfirmButton = variant === 'modal',
}: OpenAppQrPanelProps) {
  const { t } = useTranslation();

  return (
    <div className={`soundpill-open-app-qr soundpill-open-app-qr--${variant}`}>
      <GlassSurface className="soundpill-open-app-qr__panel refractive-border" rounded="2xl">
        <div className="soundpill-open-app-qr__header">
          <div className="soundpill-open-app-qr__icon-wrap" aria-hidden>
            <Icon name="qr_code_2" className="text-xl" />
          </div>
          <div className="soundpill-open-app-qr__header-text">
            <h2 className="soundpill-open-app-qr__title">{t('qrCodePopup.title')}</h2>
            <p className="soundpill-open-app-qr__hint">{t('qrCodePopup.hint')}</p>
          </div>
          <button
            type="button"
            className="soundpill-open-app-qr__close"
            onClick={onClose}
            aria-label={t('qrCodePopup.close')}
          >
            <Icon name="close" className="text-xl" />
          </button>
        </div>

        <p className="soundpill-open-app-qr__message">{t('qrCodePopup.scanQR')}</p>

        <div className="soundpill-open-app-qr__qr-wrap">
          <img
            src={QRCODE}
            className="soundpill-open-app-qr__qr-img"
            alt={t('qrCodePopup.qrAlt')}
            width={168}
            height={168}
          />
        </div>

        {showConfirmButton ? (
          <button type="button" className="soundpill-open-app-qr__confirm" onClick={onClose}>
            {t('qrCodePopup.confirm')}
          </button>
        ) : null}
      </GlassSurface>
    </div>
  );
}
